export default __webpack_public_path__ + "static/media/cg.b92309a2.svg";